var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStat1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.54545,
    height: 26,
    rx: 1.77273,
    fill: "#B519EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.09094,
    y: 7.09091,
    width: 3.54545,
    height: 18.9091,
    rx: 1.77273,
    fill: "#B519EC",
    fillOpacity: 0.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1819,
    y: 17.7273,
    width: 3.54545,
    height: 8.27273,
    rx: 1.77273,
    fill: "#B519EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2727,
    y: 3.54547,
    width: 3.54545,
    height: 22.4545,
    rx: 1.77273,
    fill: "#B519EC",
    fillOpacity: 0.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStat1);
export default __webpack_public_path__ + "static/media/ic_stat1.dd42fe065061f0d6ef3d1ac9a322f8f6.svg";
export { ForwardRef as ReactComponent };